const EditInput = ({ align, value, disabled, onChange, onBlur }) => {
  return (
    <input
      className={`
        ${align ?? "text-center"}
        w-full p-2 border-b border-b-[#EBECF1]
      `}
      disabled={disabled}
      value={value}
      onChange={onChange}
      onBlur={onBlur}
    />
  )
}

export default EditInput
